import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CollapsibleSection from './CollapsibleSection';
import { useTheme } from '../../theme';

interface DraggableSectionProps {
  id: string;
  title: string;
  defaultExpanded?: boolean;
  priority?: 'high' | 'medium' | 'low';
  children: React.ReactNode;
  isDragDisabled?: boolean;
}

const DraggableSection: React.FC<DraggableSectionProps> = ({
  id,
  title,
  defaultExpanded = false,
  priority = 'medium',
  children,
  isDragDisabled = false
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isSorting
  } = useSortable({
    id,
    disabled: isDragDisabled
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 999 : 'auto'
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`draggable-section ${isDragging ? 'dragging' : ''}`}
      {...attributes}
    >
      <CollapsibleSection
        title={title}
        sectionId={id}
        defaultExpanded={defaultExpanded}
        priority={priority}
        dragHandleProps={isDragDisabled ? undefined : listeners}
        isDragging={isDragging}
      >
        {children}
      </CollapsibleSection>
    </div>
  );
};

export default DraggableSection;